import React from 'react';
import { MoreHorizontal } from '@yme/assets/icons';
import { SVGIcon } from '@yme/atoms/svg-icon';
import { noop } from '@yme/utils/common';
import { DEFAULT_FIRST_ITEM, EMPTY_STATE, MAX_DESKTOP_ITEMS, MAX_MOBILE_ITEMS } from './constants';
const ellipsisIconProps = {
    type: EMPTY_STATE,
    onClick: () => noop(),
    children: React.createElement(SVGIcon, { type: MoreHorizontal }),
};
const getItemValue = ({ items, index }) => ({
    value: (items[index] && Number(items[index][0]) + 1) || null,
});
export function buildPaginationDesktopConfig({ items = [], activeItemValue, }) {
    const bucketCount = items?.length || 1;
    const defaultLastItem = items[0] ? Number(items[bucketCount - 1][0]) + 1 : 1;
    const isEllipsisVisible = bucketCount > MAX_DESKTOP_ITEMS;
    // isEllipsisLeft
    const isEllipsisLeft = activeItemValue > 4;
    const isEllipsisRight = defaultLastItem - activeItemValue > 3;
    const prevActiveItem = activeItemValue - 1;
    const nextActiveItem = activeItemValue + 1;
    // First Item - value
    const firstItem = {
        value: DEFAULT_FIRST_ITEM,
    };
    // Second Item - value
    const secondItem = (isEllipsisLeft && ellipsisIconProps) || {
        value: DEFAULT_FIRST_ITEM + 1,
    };
    // Third Item - value
    const thirdItem = {
        value: (!isEllipsisLeft && DEFAULT_FIRST_ITEM + 2) ||
            (!isEllipsisRight && defaultLastItem - 4) ||
            prevActiveItem,
    };
    // Forth Item - value (Middle item | if length items > 7 || MAX_DESKTOP_ITEMS)
    const fourthItem = {
        value: (!isEllipsisLeft && DEFAULT_FIRST_ITEM + 3) ||
            (!isEllipsisRight && defaultLastItem - 3) ||
            activeItemValue,
    };
    // Fifth Item - value
    const fifthItem = {
        value: (!isEllipsisLeft && DEFAULT_FIRST_ITEM + 4) ||
            (!isEllipsisRight && defaultLastItem - 2) ||
            nextActiveItem,
    };
    // Sixth Item - value
    const sixthItem = (isEllipsisRight && ellipsisIconProps) || {
        value: defaultLastItem - 1 || null,
    };
    // Seventh Item - value
    const seventhItem = {
        value: defaultLastItem,
    };
    return !isEllipsisVisible
        ? {
            firstItem: getItemValue({
                items,
                index: 0,
            }),
            secondItem: getItemValue({
                items,
                index: 1,
            }),
            thirdItem: getItemValue({
                items,
                index: 2,
            }),
            fourthItem: getItemValue({
                items,
                index: 3,
            }),
            fifthItem: getItemValue({
                items,
                index: 4,
            }),
            sixthItem: getItemValue({
                items,
                index: 5,
            }),
            seventhItem: getItemValue({
                items,
                index: 6,
            }),
        }
        : {
            firstItem,
            secondItem,
            thirdItem,
            fourthItem,
            fifthItem,
            sixthItem,
            seventhItem,
        };
}
export function buildPaginationMobileConfig({ items, activeItemValue, }) {
    const bucketCount = items.length;
    const defaultLastItem = items[0] ? Number(items[bucketCount - 1][0]) + 1 : 1;
    const isEllipsisVisible = bucketCount > MAX_MOBILE_ITEMS;
    const isEllipsisLeft = activeItemValue > 3;
    const isEllipsisRight = defaultLastItem - activeItemValue > 2;
    // First Item - value
    const firstItemMobile = {
        value: DEFAULT_FIRST_ITEM,
    };
    // Second Item - value
    const secondItemMobile = (isEllipsisLeft && ellipsisIconProps) || {
        value: DEFAULT_FIRST_ITEM + 1,
    };
    // Third Item - value (Middle item | if length items > 5)
    const thirdItemMobile = {
        value: (!isEllipsisLeft && DEFAULT_FIRST_ITEM + 2) ||
            (!isEllipsisRight && defaultLastItem - 2) ||
            activeItemValue,
    };
    // Fourth Item - value
    const fourthItemMobile = (isEllipsisRight && ellipsisIconProps) || {
        value: defaultLastItem - 1,
    };
    // Fifth Item - value
    const fifthItemMobile = {
        value: defaultLastItem,
    };
    return !isEllipsisVisible
        ? {
            firstItemMobile: getItemValue({
                items,
                index: 0,
            }),
            secondItemMobile: getItemValue({
                items,
                index: 1,
            }),
            thirdItemMobile: getItemValue({
                items,
                index: 2,
            }),
            fourthItemMobile: getItemValue({
                items,
                index: 3,
            }),
            fifthItemMobile: getItemValue({
                items,
                index: 4,
            }),
        }
        : {
            firstItemMobile,
            secondItemMobile,
            thirdItemMobile,
            fourthItemMobile,
            fifthItemMobile,
        };
}
export const buildEmptyItemsArray = (count) => Array.from(Array(count).keys());
